module.exports = {
      id: "health-usage",
      viewBox: "0 0 26.46 26.46",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#health",
      toString: function () {
        return this.url;
      }
    }